var map = {
	"./aia.svg": 3030,
	"./ant.svg": 3031,
	"./aus.svg": 3032,
	"./bah.svg": 3033,
	"./ban.svg": 3034,
	"./bar.svg": 3035,
	"./ber.svg": 3036,
	"./biz.svg": 3037,
	"./bot.svg": 3038,
	"./bru.svg": 3039,
	"./can.svg": 3040,
	"./cay.svg": 3041,
	"./cmr.svg": 3042,
	"./cok.svg": 3043,
	"./cyp.svg": 3044,
	"./dma.svg": 3045,
	"./eng.svg": 3046,
	"./fij.svg": 3047,
	"./flk.svg": 3048,
	"./gab.svg": 3049,
	"./gam.svg": 3050,
	"./ggy.svg": 3051,
	"./gha.svg": 3052,
	"./gib.svg": 3053,
	"./grn.svg": 3054,
	"./guy.svg": 3055,
	"./ind.svg": 3056,
	"./iom.svg": 3057,
	"./ivb.svg": 3058,
	"./jam.svg": 3059,
	"./jey.svg": 3060,
	"./ken.svg": 3061,
	"./kir.svg": 3062,
	"./lca.svg": 3063,
	"./les.svg": 3064,
	"./manifest.json": 867,
	"./mas.svg": 3065,
	"./maw.svg": 3066,
	"./mdv.svg": 3067,
	"./mlt.svg": 3068,
	"./moz.svg": 3069,
	"./mri.svg": 3070,
	"./msr.svg": 3071,
	"./nam.svg": 3072,
	"./nfk.svg": 3073,
	"./ngr.svg": 3074,
	"./nir.svg": 3075,
	"./niu.svg": 3076,
	"./nru.svg": 3077,
	"./nzl.svg": 3078,
	"./pak.svg": 3079,
	"./png.svg": 3080,
	"./rsa.svg": 3081,
	"./rwa.svg": 3082,
	"./sam.svg": 3083,
	"./sco.svg": 3084,
	"./sey.svg": 3085,
	"./sgp.svg": 3086,
	"./shn.svg": 3087,
	"./skn.svg": 3088,
	"./sle.svg": 3089,
	"./sol.svg": 3090,
	"./sri.svg": 3091,
	"./svg-country.svg": 3092,
	"./swz.svg": 3093,
	"./tan.svg": 3094,
	"./tca.svg": 3095,
	"./tga.svg": 3096,
	"./tog.svg": 3097,
	"./tto.svg": 3098,
	"./tuv.svg": 3099,
	"./uga.svg": 3100,
	"./van.svg": 3101,
	"./wal.svg": 3102,
	"./zam.svg": 3103
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3029;